export const SWISH_GC_CHECKOUT_FEATURE_FLAG = 'swish_gc_checkout';
export const QLIRO_GC_CHECKOUT_FEATURE_FLAG = 'qliro_gc_checkout';
export const NEW_PLACE_TWEAKS_EXPERIMENT = 'new-place-page-tweaks';
export const MEGA_MENU_NAVIGATION_FEATURE_FLAG_PLACE_ONLY = {
  name: 'megamenu-navigation-place-only-v2',
  defaultValue: { enabled: true },
};
export const CHECKOUT_REDESIGN_FEATURE_FLAG = 'checkout_redesign';
export const FINNISH_TRANSLATION_FEATURE_FLAG = 'finnish-translation';
export const NEAR_ME_FLAG = 'near-me-autoscaling';
export const DEALS_FEATURE = {
  name: 'deals',
  defaultValue: { enabled: true },
};
// add here all the search flags that should be sent to the backend
export const SEARCH_FLAGS = [NEAR_ME_FLAG];
export const MEGA_MENU_NAVIGATON_EXCLUDING_PLACE = {
  name: 'megamenu-navigation-excl-place',
  defaultValue: { enabled: true },
};

export const WEB_TEST_FLAG = { name: 'web-test-flag', defaultValue: { newTestVariant: false } };

export const PHYSICAL_GIFTCARD_FEATURE_FLAG = {
  name: 'physical-giftcard',
  defaultValue: { enabled: false },
};

export const BOOKING_FLOW_REDESIGN_FLAG = {
  name: 'booking-flow-redesign',
  defaultValue: { enabled: false },
};

/**
 * Kill switch for the redesigned weekpicker, ANDed with BOOKING_FLOW_REDESIGN_FLAG. Default
 * enabled — flipping it off in Confidence takes the picker down for everyone in the redesign
 * cohort without rolling back the rest of the redesign.
 */
export const NEW_WEEKPICKER_FLAG = {
  name: 'new-weekpicker',
  defaultValue: { enabled: true },
};

// Empty default (no `banner`) means the banner is hidden.
export const USER_INFO_BANNER_FLAG = {
  name: 'user-info-banner',
  defaultValue: {},
};

/** One flag so a visitor's reviews-v2 and listcards-v2 arms are assigned together. */
export const REVIEWS_V2_LISTCARDS_V2_FLAG: {
  name: string;
  defaultValue: { 'reviews-v2': boolean; 'listcards-v2': boolean };
} = {
  name: 'reviewsv2-listcardsv2-combined',
  defaultValue: { 'reviews-v2': false, 'listcards-v2': false },
};

export type SerpTabsVariant = 'control' | 'tabbed';

export const SERP_TABS_FLAG: { name: string; defaultValue: { variant: SerpTabsVariant } } = {
  name: 'serp-tabs',
  defaultValue: { variant: 'control' },
};
